import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/env';

@Injectable({
  providedIn: 'root',
})
export class Mtm {

  private apiUrl = environment.BASE_URL + `/ptp/`;
  public header = { headers: { 'Access-Control-Allow-Origin': '*' } };

  constructor(private http: HttpClient) { }

   public getRejectionReasons(): Observable<any> {
      return this.http.get<any[]>(this.apiUrl + `api/spp/mtm/rejection-details`, this.header);
   }

  public yoodlipheseoneRegister(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrl + `api/public/mct/yoodli/register/phase1`, payload, this.header);
  }

  public getmtmDetails(payload: any): Observable<any> {  
    return this.http.post<any>(this.apiUrl + `api/spp/dashboard/userDetails/mtm-eligibility`, payload, this.header);
  }

  public getRenewalUser(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + 'api/spp/mtm/renewalUserDetails', this.header);
  }
}
